import React, { FunctionComponent, ReactNode } from "react";

const WithIcon: FunctionComponent<
  React.PropsWithChildren<{
    icon: ReactNode;
    top?: boolean;
    iconClassName?: string;
  }>
> = ({ icon, top, iconClassName, children }) => {
  return (
    <span className={`flex ${top ? "items-start" : "items-center"} space-x-2`}>
      <span className={`${iconClassName || ""}`}>{icon}</span>
      <span>{children}</span>
    </span>
  );
};

export default WithIcon;
